
import React, { Component } from 'react';
import FakeData from '.././fake-data';
import ReactDOM from 'react-dom';
import { Link, Redirect } from 'react-router-dom';
import SoccerPitch from '.././components/SoccerPitch';
import { Img } from '.././components/Common';
import { Helmet } from "react-helmet";
import './TacticBoard.css';
import LineupLimit from '../components/SportLineLimit';

export default class TacticBoard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            team: { id: null, squadId: null, name: "", players: [] },
            teams: [],
            sports: ["soccer", "rugby", "cricket", "netball","field hockey"],
            error: { team: false }
        }

        this.onTeamSelected = this.onTeamSelected.bind(this);
    }

    componentDidMount() {
        FakeData.mountState("tactic", true)
        this.getTeams()
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.match.params.sport !== nextProps.match.params.sport || this.props.location.search !== nextProps.location.search) {
            const _that = this
            FakeData.mountState("tactic", false)
            this.setState({
                team: { id: null, squadId: null, name: "", players: [] }
            });

            setTimeout((() => {
                FakeData.mountState("tactic", true)
                _that.getTeams()
            }), 1000)

            return true;
        }

        return true
    }

    onTeamSelected(e) {
        const value = e.target.value;
        const { team, teams, sports, error } = this.state
        let list = teams;
        let index = teams.findIndex((item) => item.name == value);
        list[index].selected = true;
        if (index > -1) {
            error.team = false
            this.setState({
                team: list[index],
                error
            });
        } else {
            error.team = true
            this.setState({
                error
            });
        }
    }

    getTeams() {
        const _that = this
        if (!FakeData.isMounted("tactic")) {
            setTimeout(() => {
                _that.getTeams()
            }, 1000)

            return;
        }
        const list = FakeData.listify((FakeData.getData("yoo").ownTeams) ? FakeData.getData("yoo").ownTeams : [])
        if (list.length === 0) {
            setTimeout(() => {
                _that.getTeams()
            }, 1000)

            return;
        }

        const newState = Object.assign(_that.state, {
            teams: list
        })

        _that.setState(newState)
    }

    getSportTeams = () => {
        const { match } = this.props
        const { teams } = this.state
        const list = [];
        teams.forEach((item, i) => {
            if (item.sport.toLowerCase() === FakeData.nullify(match.params.sport).toLowerCase()) {
                list.push(item)
            }
        })

        return list;
    }

    render() {
        const { team, teams, sports, error } = this.state
        const { match } = this.props
        const {lineup, subs} = LineupLimit[this.props.match.params.sport.toLowerCase()];
        const bool = FakeData.inArray(FakeData.nullify(match.params.sport).toLowerCase(), sports)
        if (!bool) {
            return (<Redirect
                to={{ pathname: "/404" }}
            />)
        }
        if (teams.length === 0) {
            return (
                <div className="gmc-before">
                    <div className="loader">
                        <h1>Please wait...</h1>
                        <div className="spinner"></div>
                    </div>
                </div>
            );
        }
        return (
            <div className="" style={{ width: "80vw" }}>
                <Helmet
                    title={"Tactics Board"}
                    meta={[
                        { "name": "description", "content": "Description of page" },
                        { property: "og:type", content: "tactics.board" },
                        { property: "og:title", content: "Tactics Board" },
                        { property: "og:image", content: "" },
                        { property: "og:url", content: FakeData.baseURL + "/#" + this.props.location.pathname + this.props.location.search }
                    ]}
                />
                {(team.id === null && team.squadId === null) &&
                    <div className="tactic-board-before-pick">
                        Select team
                        <select value={team.name} className={(error.team) ? "error" : ""} onChange={this.onTeamSelected}>
                            <option value="">Select your team</option>
                            {
                                this.getSportTeams().map((item, i) => {
                                    return (
                                        <option key={i} value={item.name}>{item.name}</option>
                                    )
                                })
                            }
                        </select>
                        <button className="button">Set Team</button>
                    </div>
                }
                {(team.id !== null && team.squadId !== null) &&
                    <SoccerPitch maxLineup={lineup} isBoard={true} sport={match.params.sport} team={team} players={team.players} maxSubs={subs} />
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/TacticBoard.jsx